

var isOpen = false;
var gallery; //, options; //, items;
var currentItems;
var galleryTimeout, windowResizeTimeout;
var galleryElement = document.getElementById('gallery');
var galleryElementStory = document.getElementById('galleryEnd');
var smoothScroll = document.querySelectorAll('.smooth-scroll')[0];
var fadeItem = document.querySelectorAll('.pswp__fade-item')[0];
var pswp = document.querySelectorAll('.pswp')[0];

var openPhotoSwipe, parseThumbnailElements;
var options, items;


const MEDIUM_BREAKPOINT = 1024;
const SMALL_BREAKPOINT = 768;

// create variable that will store real size of viewport
var realViewportWidth,
    useLargeImages = false,
    useMediumImages = false,
    firstResize = true,
    imageSrcWillChange;


var initPhotoSwipeFromDOM = function (gallerySelector) {

    // parse slide data (url, title, size ...) from DOM elements 
    // (children of gallerySelector)
    parseThumbnailElements = function (el) {
        var viewPortWidth = window.innerWidth;
        var thumbElements = el.childNodes,
            numNodes = thumbElements.length,
            items = [],
            figureEl,
            figureImg,
            linkEl,
            size,
            centerPoint,
            item,
            dataSrc,
            viewPortWidth;


        for (var i = 0; i < numNodes; i++) {

            figureEl = thumbElements[i]; // <figure> element

            // include only element nodes 
            if (figureEl.nodeType !== 1) {
                continue;
            }

            linkEl = figureEl.children[0]; // <a> element
            figureImg = linkEl.children[0];

            size = linkEl.getAttribute('data-size').split('x');
            centerPoint = linkEl.getAttribute('data-centerpoint').split('|');

            //consoleLogger("parseThumbnailElements > useLargeImages: " + useLargeImages);
            //consoleLogger("window.innerWidth: " + $(window).width());
            let windowWidth = $(window).width();
            let origImg;

            if (windowWidth <= SMALL_BREAKPOINT) {
                dataSrc = figureImg.src;
                origImg = dataSrc;
            } else if (windowWidth > SMALL_BREAKPOINT && windowWidth <= MEDIUM_BREAKPOINT) {
                dataSrc = linkEl.getAttribute('data-src-med');
                origImg = dataSrc;
            } else if (windowWidth > MEDIUM_BREAKPOINT) {
                dataSrc = linkEl.getAttribute('data-src-high');
                origImg = dataSrc;
            }



            // create slide object
            item = {
                //src: linkEl.getAttribute('href'),
                src: dataSrc,
                w: parseInt(size[0], 10),
                h: parseInt(size[1], 10),
                centerPoint: { x: centerPoint[0], y: centerPoint[1] },
                mediumImage: {
                    src: linkEl.getAttribute('data-src-med')
                },
                originalImage: {
                    src: origImg
                }
            };



            if (figureEl.children.length > 1) {
                // <figcaption> content
                item.title = figureEl.children[1].innerHTML;
            }

            if (linkEl.children.length > 0) {
                // <img> thumbnail element, retrieving thumbnail url
                item.msrc = linkEl.children[0].getAttribute('src');
            }

            item.el = figureEl; // save link to element for getThumbBoundsFn
            items.push(item);

        }
        return items;
    };

    //build items from thumbnails
    //items = parseThumbnailElements(galleryElement);

    // find nearest parent element
    var closest = function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function (e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        var eTarget = e.target || e.srcElement;

        // find root element of slide
        var clickedListItem = closest(eTarget, function (el) {
            return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
        });

        if (!clickedListItem) {
            return;
        }

        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        var clickedGallery = clickedListItem.parentNode,
            childNodes = clickedListItem.parentNode.childNodes,
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;

        //consoleLogger("onThumbnailsClick");
        //consoleLogger(clickedGallery);

        //if this gallery is the end gallery make sure is-ended classes are added 
        if (clickedGallery.classList.contains("lh-gallery--story")) {
            document.getElementsByTagName("html")[0].classList.add('is-ended', 'gallery-mode', 'gallery-open');
            pswp.classList.add("is-ended");
        }


        for (var i = 0; i < numChildNodes; i++) {
            if (childNodes[i].nodeType !== 1) {
                continue;
            }

            if (childNodes[i] === clickedListItem) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }



        if (index >= 0) {
            // open PhotoSwipe if valid index found
            openPhotoSwipe(index, clickedGallery);
        }
        return false;
    };

    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll(gallerySelector);
    
    consoleLogger("galleryElements.length: " + galleryElements.length);

    for (var i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i + 1);
        galleryElements[i].onclick = onThumbnailsClick;
    }
    
    reportWindowSize();

    window.addEventListener("resize", reportWindowSize);

};

function reportWindowSize() {
    //consoleLogger("reportWindowSize");
    clearTimeout(windowResizeTimeout);
    windowResizeTimeout = setTimeout(function(){
        resizeThumbnailElements(galleryElement);
        resizeThumbnailElements(galleryElementStory);
    },400);
}

function resizeThumbnailElements(el) {

    var thumbElements = el.childNodes,
        numNodes = thumbElements.length,
        figureEl,
        figureImg,
        linkEl,
        size,
        centerPoint;

    for (var i = 0; i < numNodes; i++) {

        figureEl = thumbElements[i]; // <figure> element

        // include only element nodes 
        if (figureEl.nodeType !== 1) {
            continue;
        }

        linkEl = figureEl.children[0]; // <a> element
        figureImg = linkEl.children[0];

        size = linkEl.getAttribute('data-size').split('x');
        centerPoint = linkEl.getAttribute('data-centerpoint').split('|');

        //first set proper size of thumbnail
        var w = size[0];
        var h = size[1];
        var tw = figureEl.offsetWidth; // + 1;
        var th = figureEl.offsetHeight; // + 1;

        figureImg.style.width = tw + 'px';
        figureImg.style.height = 'auto';

        if (figureImg.offsetHeight < th) {
            figureImg.style.height = th + 'px';
            figureImg.style.width = 'auto';
        }

        //Now position thumbnail based on centerpoint
        var imgW = figureImg.offsetWidth;
        var imgH = figureImg.offsetHeight;
        var hRatio = window.innerWidth / w;
        var vRatio = window.innerHeight / h;

        fitRatio = hRatio < vRatio ? hRatio : vRatio;
        fillRatio = hRatio > vRatio ? hRatio : vRatio;

        var zoomLevel = fillRatio;
        var scaleW = imgW / w;
        var scaleH = imgH / h;
        
        consoleLogger("");
        consoleLogger("resizeThumbnailElements >");
        consoleLogger("window.innerHeight: " + window.innerHeight);
        //consoleLogger(figureImg);
        consoleLogger("zoomLevel: " + zoomLevel);
        consoleLogger("fitRatio: " + fitRatio);
        consoleLogger("fillRatio: " + fillRatio);
        consoleLogger("imgW: " + imgW);
        consoleLogger("imgH: " + imgH);
        consoleLogger("scaleW: " + scaleW);
        consoleLogger("scaleH: " + scaleH);
        
        var xPos = -scaleW * centerPoint[0];
        var yPos = -scaleH * centerPoint[1];

        //check bounds
        if (yPos > 0) {
            yPos = 0;
        } else if (yPos < th - imgH) {
            yPos = th - imgH;
        }

        if (xPos > 0) {
            xPos = 0;
        } else if (xPos < tw - imgW) {
            xPos = tw - imgW;
        }


        consoleLogger("xPos: " + xPos);
        consoleLogger("yPos: " + yPos);
        consoleLogger("centerPoint.x: " + centerPoint[0]);
        consoleLogger("centerPoint.y: " + centerPoint[1]);

        figureImg.style.transform = "translate(" + xPos + "px," + yPos + "px)";
    }
}

openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
    consoleLogger("openPhotoSwipe: " + index);
    consoleLogger(galleryElement);

    
    items = parseThumbnailElements(galleryElement);
    currentItems = items;

    //consoleLogger(items);

    // define options
    options = {
        // define gallery index (for URL)
        galleryUID: galleryElement.getAttribute('data-pswp-uid'),
        showHideOpacity: true,
        closeElClasses: [''],
        barsSize: { top: 0, bottom: 0 },
        counterEl: false,
        hideAnimationDuration: 700, showAnimationDuration: 700,
        history: false,
        bgOpacity: 1,
        spacing: 0, //Spacing ratio between slides. For example, 0.12 will render as a 12% of sliding viewport width (rounded).
        allowPanToNext: true,

        //opens from thumbnail
        getThumbBoundsFn: function (index) {
            //if(mode === GALLERY_MODE){
            // See Options -> getThumbBoundsFn section of documentation for more info

            var figure = galleryElement.getElementsByTagName('figure')[index];
            consoleLogger(galleryElement);
            consoleLogger(figure);
            consoleLogger("getThumbBoundsFn index: " + index);
            //var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
            var thumbnail = figure.getElementsByTagName('img')[0],
                pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                rect = thumbnail.getBoundingClientRect();

            consoleLogger("getThumbBoundsFn >>> pageYScroll: " + pageYScroll);
            //consoleLogger(thumbnail);
            consoleLogger(rect);

            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
            //}
        },


        getDoubleTapZoom: function (isMouseClick, item) {
            var fitRatio = item.fitRatio;
            //consoleLogger(item);
            //consoleLogger("getDoubleTapZoom: initialZoomLevel: " + item.initialZoomLevel);
            //consoleLogger("item.fitRatio: " + item.fitRatio);

            var zoomLevel = item.fitRatio; //getDestZoomLevel(); 
            //var zoomedOutLevel = item.initialZoomLevel;
            //consoleLogger("zoomLevel: " + zoomLevel);
            return zoomLevel;
        },
        //zoomEl: false,
        //fullscreenEl: true,
        history: false,
        escKey: false,
        closeOnScroll: false,
        scaleMode: 'fill', //'fit'

    };

    options.index = parseInt(index, 10);

    // exit if index not found
    if (isNaN(options.index)) {
        return;
    }

    if (disableAnimation) {
        options.showAnimationDuration = 0;
    }

    gallery = new PhotoSwipe(pswp, PhotoSwipeUI_Default, items, options);
    // Pass data to PhotoSwipe and initialize it

    //responsive
    // beforeResize event fires each time size of gallery viewport updates
    gallery.listen('beforeResize', function () {
        // gallery.viewportSize.x - width of PhotoSwipe viewport
        // gallery.viewportSize.y - height of PhotoSwipe viewport
        // window.devicePixelRatio - ratio between physical pixels and device independent pixels (Number)
        //                          1 (regular display), 2 (@2x, retina) ...


        // calculate real pixels when size changes
        realViewportWidth = gallery.viewportSize.x * window.devicePixelRatio;

        // Code below is needed if you want image to switch dynamically on window.resize

        // Find out if current images need to be changed

        if (realViewportWidth <= SMALL_BREAKPOINT) {
            useLargeImages = false;
            useMediumImages = false;
            imageSrcWillChange = false;
        } else if (realViewportWidth <= MEDIUM_BREAKPOINT) {
            useLargeImages = false;
            useMediumImages = true;
            imageSrcWillChange = true;
        } else if (realViewportWidth > MEDIUM_BREAKPOINT) {
            useLargeImages = true;
            useMediumImages = false;
            imageSrcWillChange = true;
        }
        /*if(useLargeImages && realViewportWidth <= MEDIUM_BREAKPOINT) {
            useLargeImages = false;
            imageSrcWillChange = true;
        } else if(!useLargeImages && realViewportWidth > MEDIUM_BREAKPOINT) {
            useLargeImages = true;
            imageSrcWillChange = true;
        }*/


        // Invalidate items only when source is changed and when it's not the first update
        if (imageSrcWillChange && !firstResize) {
            // invalidateCurrItems sets a flag on slides that are in DOM,
            // which will force update of content (image) on window.resize.
            gallery.invalidateCurrItems();
        }

        if (firstResize) {
            firstResize = false;
        }

        imageSrcWillChange = false;

    });


    // gettingData event fires each time PhotoSwipe retrieves image source & size
    gallery.listen('gettingData', function (index, item) {

        consoleLogger("gettingData: " + index);
        // Set image source & size based on real viewport width
        if (useLargeImages) {
            item.src = item.originalImage.src;
            //item.w = item.originalImage.w;
            //item.h = item.originalImage.h;
        } else if (useMediumImages) {
            item.src = item.mediumImage.src;
            //item.w = item.mediumImage.w;
            //item.h = item.mediumImage.h;
        } else {
            item.src = item.msrc;
        }

        // It doesn't really matter what will you do here, 
        // as long as item.src, item.w and item.h have valid values.
        // 
        // Just avoid http requests in this listener, as it fires quite often

    });

    gallery.init();

    isOpen = true;

    //Set up Listeners

    // Resize
    gallery.listen('resize', function () {
        consoleLogger("  EVENT CALL: resize");

    });

    // Opening zoom in animation starting
    gallery.listen('initialZoomIn', function () {
        consoleLogger("  EVENT CALL: initialZoomIn");

    });

    // Opening zoom in animation finished
    gallery.listen('initialZoomInEnd', function () {

        consoleLogger("  EVENT CALL:initialZoomInEnd");
        document.getElementsByTagName("html")[0].classList.add('gallery-open');
    });

    // Closing zoom out animation started
    gallery.listen('  EVENT CALL:initialZoomOut', function () { consoleLogger("initialZoomOut"); });

    // Closing zoom out animation finished
    gallery.listen('  EVENT CALL:initialZoomOutEnd', function () { consoleLogger("initialZoomOutEnd"); });

    // Gallery starts closing
    gallery.listen('close', function () {
        consoleLogger("  EVENT CALL: gallery closing");
        //isOpen = false;
        document.getElementsByTagName("html")[0].classList.remove('gallery-open');
    });

    gallery.listen('afterChange', function () {
        consoleLogger("slide has changed");
        fadeItem.classList.remove('show');

    });


    // Gallery unbinds events
    // (triggers before closing animation)
    gallery.listen('unbindEvents', function () { consoleLogger("  EVENT CALL: EVENT CALL: gallery unbindEvents"); });

    // After gallery is closed and closing animation finished.
    // Clean up your stuff here.
    gallery.listen('destroy', function () {
        consoleLogger("  EVENT CALL: destroy gallery ");
        
        clearTimeout(galleryTimeout);
        galleryTimeout = setTimeout(function () {
            pswp.classList.remove("is-ended");
            pswp.classList.remove("pswp--open");
            isOpen = false;
            consoleLogger("isOpen: " + isOpen);
        }, 100);

    });


    function zoomToComplete(e) {
        consoleLogger("zoomToComplete");
        //consoleLogger(e);
    }
};


function consoleLogger(msg) {
    // consoleLogger(msg);
}



export function hidePhotoGrid(bool) {
    if (bool) {
        galleryElement.classList.add("hide");
    } else {
        galleryElement.classList.remove("hide");
    }
}

export function resizePhotoSwiper(index) {
    
    if(gallery){
        //console.log("resizePhotoSwiper: index: " + index)
        reportWindowSize();
        setTimeout(function(){
            gallery.updateSize(true);
        },250);
    }
}

export function closePhotoSwiper(isMobile = false) {
    consoleLogger("closePhotoSwiper >  isMobile: " + isMobile);
    if(isOpen){
        gallery.close();
    }

    if ($('html').hasClass("is-ended") && !isMobile) {
        smoothScroll.classList.add("hide");
    }

    //add scroll listener for non mobile devices
    if (!isMobile) {
        galleryElement.addEventListener('wheel', scrollOnGallery);
    }

    function scrollOnGallery(event) {
        event.preventDefault();
        consoleLogger(event.deltaY);
        if (event.deltaY < 0) {
            galleryElement.removeEventListener('wheel', scrollOnGallery);
            smoothScroll.classList.remove("hide");
        }
    }
}

export function fadeToPhoto(index) {
    consoleLogger(": : : : : : fadeToPhoto: " + index + ", isOpen: " + isOpen);
    
    if (!isOpen) {
        openPhotoSwipe(index, galleryElement);
    } else {
        consoleLogger("currentIndex: " + gallery.getCurrentIndex());

        if (index != gallery.getCurrentIndex()) {
            gallery.loadFadeToImg(index, fadeItem);
        } else {
            //gallery.zoomTo()
            consoleLogger(currentItems[index]);
            var item = currentItems[index];
            gallery.zoomTo(item.initialZoomLevel, item.initialPosition, 1000);
            //gallery.updateSize(true);
        }

    }
};

export function initPhotoSwiper() {
    // execute above function
    initPhotoSwipeFromDOM('.lh-gallery');
    //initPhotoSwipeFromDOM('#galleryEnd');
}